import "./AppInfo.css";
import React from "react";
import Footer from "./infPages/Footer";

function AppInfo(props) {
  return (
    <div className="appInfoPage">
          <a className="" href="/">
          <p className="backToHomeText"> head back to home!</p>
        </a>
        <p className="appInfoHeaderText"> about noodlepedia </p>
        <p className="infText"> When we closed our restaurants in NYC, we wanted to keep the brand alive in a small way. We created Noodlepedia to serve as an online instant noodle dictionary - with details, ratings, and reviews of all of the noodles we used to serve in our restaurant. Our personal favorites? Tseng Sichuan Pepper Pulled Noodles and Bibim Men Spicy Noodles. </p>

        <p className="infText"> looking for info on the Instant Noodle Factory restaurant? <a className="href" href="/instantnoodlefactory"> Click here! </a></p>
    <Footer />
    </div>
  );
}

export default AppInfo;
